import React from 'react'
import Page from 'src/components/Page'
import RegisterEmailSent from './components/RegisterEmailSent'
import cx from 'classnames'
import styles from 'src/features/static/Static.module.sass'

const EmailSentPage = () => {
  return (
    <Page className={cx(styles.static, styles.centered)}>
      <RegisterEmailSent />
    </Page>
  )
}

export default EmailSentPage
